import Editor from "../../Components/common/Editor";
import ImageIcon from "../../../assets/icons/image.svg";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";
import { Form, Button, Input, Card, message } from "antd";
import React, { useState, useEffect } from "react";
import trans from "../../../Languages/Languages";
import API from "../../../API";

const News = () => {
  const [newsData, setNewsData] = useState([]);
  const [newData, setNewData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const handleAnotherNews = () => {
    setLoading(true);
    const dummyData = [
      {
        title: "",
        description: "",
        text: "",
        images: [],
        new: true,
      },
      ...newsData,
    ];
    setNewsData(dummyData);

    const newDummyData = [
      {
        title: "",
        description: "",
        text: "",
        images: [],
        new: true,
      },
      ...newData,
    ];
    setNewData(newDummyData);

    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const [loading, setLoading] = useState(true);

  // Use Effect
  useEffect(() => {
    setLoading(true);

    const init = async () => {
      await API.get("/admin/news")
        .then((res) => {
          setNewsData(res.data);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    };

    init();
  }, [refresh]);

  // create new records
  const handleCreateNew = async () => {
    setLoading(true);
    if (newData.length > 0) {
      const formData = new FormData();

      newData.forEach((element, i) => {
        formData.append(`news[${i}][title]`, element.title);
        formData.append(`news[${i}][description]`, element.description);
        formData.append(`news[${i}][text]`, element.text);
        element.images.forEach((img, imgIndex) => {
          formData.append(`news[${i}][images][${imgIndex}]`, img);
        });
      });

      await API.post("/admin/news/create", formData)
        .then((res) => {
          setNewData([]);
          message.success("News Created Successfully.");
          setLoading(false);
          setRefresh(!refresh);
        })
        .catch((e) => {
          if (e?.response?.status === 400) {
            message.error("Field is required");

            // error for only image size must not be greater than 5 MB.
            if (e?.response?.data["news.0.image"]) {
              if (e?.response?.data["news.0.image"][0].includes("5120")) {
                message.error("The image must not be greater than 5 MB.");
              }
            }
          }
          setLoading(false);
        });
    }
  };

  return (
    <div className="pages-container">
      <Card bordered={false} className="p-0" loading={loading}>
        {newData.length > 0 && (
          <Button
            onClick={handleCreateNew}
            className="btn-save-changes"
            type="primary"
            htmlType="submit"
          >
            {trans.Save}
          </Button>
        )}

        {newsData &&
          newsData.map((item, i) => {
            return (
              <div className="content-wrapper news-content" key={i}>
                <AddNews
                  index={i}
                  data={item}
                  setData={setNewsData}
                  originalData={newsData}
                  refresh={refresh}
                  setRefresh={setRefresh}
                  setLoading={setLoading}
                  newData={newData}
                  setNewData={setNewData}
                />
              </div>
            );
          })}

        {/* add another */}
        <div className="w-100 d-flex justify-content-center">
          <div className="news-add-another" onClick={handleAnotherNews}>
            <span className="f-12 fw-500">
              {trans.Addanother}
              <span className="ml-1 f-20 fw-500 align-middle">+</span>
            </span>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default News;

const AddNews = ({
  data,
  index,
  originalData,
  setData,
  newData,
  setNewData,
  setLoading,
  refresh,
  setRefresh,
}) => {
  const [editorHtml, setEditorHtml] = useState("");

  const handleTextEditorChange = (html) => {
    setEditorHtml(html);
    if (index <= newData.length - 1) {
      const dummyNewData = [...newData];
      dummyNewData[index].text = html;
      setNewData(dummyNewData);
    }
  };

  const [edit, setEdit] = useState(false);
  const [currentImageObject, setCurrentImageObject] = useState({ image: "" });
  const handleMultipleImages = (e) => {
    const files = Array.from(e.target.files);
    const previews = files.map(file => URL.createObjectURL(file));
  
    // Update preview URLs
    const dummyData = [...originalData];
    dummyData[index].images = previews;
    setData(dummyData);
  
    // Update currentImageObject for upload
    setCurrentImageObject({ image: files });
  
    // If new record, also update newData
    if (data.new) {
      const dummyNewData = [...newData];
      dummyNewData[index].images = files;
      setNewData(dummyNewData);
    }
  };
  

  const inputReplace = React.createRef();
  const [isActionShown, setIsActionShown] = useState(false);

  // remove image
  const handleRemove = () => {
    const dummyData = [...originalData];
    dummyData[index].images = [];
    setData(dummyData);

    if (data.new) {
      const dummyNewData = [...newData];
      dummyNewData[index].images = [];
      setNewData(dummyNewData);
    }
  };


  useEffect(() => {
    setEditorHtml(data.text);
  }, [data]);

  // update record
  const handleSectionSave = async (values) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("description", values.description);
    formData.append("text", editorHtml);
  
    if (currentImageObject.image && currentImageObject.image.length > 0) {
      // New images uploaded → replace all old images
      const imagesArray = Array.isArray(currentImageObject.image)
        ? currentImageObject.image
        : [currentImageObject.image];
  
      imagesArray.forEach((img, idx) => {
        formData.append(`images[${idx}]`, img);
      });
    } else {
      // No new images → keep existing images from database
      const existingImages = Array.isArray(data.images)
        ? data.images
        : JSON.parse(data.images || "[]"); // parse JSON string if needed
  
      existingImages.forEach((img, idx) => {
        formData.append(`existing_images[${idx}]`, img);
      });
    }
  
    try {
      await API.post(`/admin/news/update/${data.id}`, formData);
      setRefresh(!refresh);
      message.success("News Updated Successfully");
    } catch (e) {
      message.error("Field is required.");
    } finally {
      setLoading(false);
    }
  };
  
  


  const handleInputValueChange = ({ target }) => {
    if (index >= 0 && newData.length > 0 && data.new) {
      const dummyNewData = [...newData];
      dummyNewData[index][target.name] = target.value;
      setNewData(dummyNewData);
    }
  };

  const handleNewNewsDelete = (index) => {
    const dummyData = originalData.filter((item, i) => {
      return index !== i;
    });
    setData(dummyData);
    let newIndex = newData.length + index - originalData.length;
    let newRecord = [];
    newRecord = newData.filter((item, i) => {
      return newIndex !== i;
    });
    setNewData(newRecord);
  };
  ///////////////////////////////////////////////////////////////////////////////////////////////
  ///                             delete record
  ////////////////////////////////////////////////////////////////////////////////////////////////
  const handleNewsDelete = async () => {
    setLoading(true);

    await API.post(`/admin/news/delete/${data.id}`)
      .then((res) => {
        setRefresh(!refresh);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  return (
    <div className="bg-content-container faculty-container ">
      <Form onFinish={handleSectionSave}>
        {/* edit action */}
        <div style={{ height: 10 }}>
          {edit ? (
            <div className="edit-action icon-container d-block mr-1">
              <span
                className="f-12 fw-400 cancel cursor-pointer"
                onClick={() => setEdit(false)}
              >
                {trans.Cancel}
              </span>

              <span className="save">
                <Button type="" htmlType="submit">
                  {trans.Save}
                </Button>
              </span>
            </div>
          ) : (
            <div className="icon-container">
              {!data.new && (
                <span onClick={() => setEdit(true)}>
                  <EditIcon className="b-icon-edit cursor-pointer" />
                </span>
              )}
              <CloseIcon
                className="b-icon-close cursor-pointer"
                onClick={() => {
                  data.new
                    ? handleNewNewsDelete(index)
                    : handleNewsDelete(index);
                }}
              />
            </div>
          )}
        </div>

        {/* news header image upload */}
        <div
          className={
            data.image !== "" && data.image
              ? "news-image-upload-container news-image uploaded"
              : "news-image-upload-container news-image"
          }
        >
          <div
            className={"news-image-upload medium-img"}
            onMouseEnter={() => setIsActionShown(true)}
            onMouseLeave={() => setIsActionShown(false)}
          >
            {isActionShown && (edit || data.new) && (
              <div>
                {/* image action */}
                <div className="image-action-container">
                  <div className="image-action d-flex justify-content-center">
                    <div
                      className="f-9 fw-400 image-action-txt"
                      onClick={handleRemove}
                    >
                      {trans.Remove}
                    </div>
                  </div>
                </div>
              </div>
            )}
            <label className="news-image-box" htmlFor={`news${index}`}>
              {Array.isArray(data.images) || data.images ? (() => {
                // Safely parse JSON string if needed
                let images = [];
                try {
                  images = Array.isArray(data.images) ? data.images : JSON.parse(data.images);
                } catch (e) {
                  images = [];
                }
                return images.length > 0 ? (
                  <div className="d-flex flex-wrap gap-2">
                    {images.map((img, i) => (
                      <div
                        key={i}
                        className="wide-image-preview-news"
                        style={{
                          background: `url("${img}")`,
                          height: 152,
                          width: 220,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                      />
                    ))}
                  </div>
                ) : (
                  <div className="cursor-pointer">
                    <img src={ImageIcon} alt="" className="pl-1 pr-1" />
                    <span className="f-12 fw-400 pr-1">Upload Images</span>
                  </div>
                );
              })() : (
                <div className="cursor-pointer">
                  <img src={ImageIcon} alt="" className="pl-1 pr-1" />
                  <span className="f-12 fw-400 pr-1">Upload Images</span>
                </div>
              )}


              <input
                multiple
                disabled={edit || data.new ? "" : "disabled"}
                ref={inputReplace}
                type="file"
                name="image1"
                id={`news${index}`}
                style={{ display: "none" }}
                onChange={handleMultipleImages}
              />
            </label>
          </div>
          <span className="float-left f-img-size f-12 fw-400">
            {trans.Maxsize} : 5MB {trans.RecommendedResolution} : 1920 x 1080
          </span>
        </div>
        {/* end */}
        <div>
          <div className="accordion-detail ">
            <div className="f-12 fw-500 faculty-heading">{trans.Name}</div>
            <Form.Item name="title" initialValue={data.title}>
              <Input
                onChange={handleInputValueChange}
                name="title"
                disabled={edit || data.new ? "" : "disabled"}
                placeholder={trans.Typehere}
              />
            </Form.Item>
          </div>
          <div className="accordion-detail  college-text-area">
            <div className="f-12 fw-500 faculty-heading">
              {trans.Description}
            </div>
            <Form.Item name="description" initialValue={data.description}>
              <Input.TextArea
                name="description"
                onChange={handleInputValueChange}
                disabled={edit || data.new ? "" : "disabled"}
              ></Input.TextArea>
            </Form.Item>
          </div>
        </div>

        {/* Faculties text Area */}

        <div className="f-12 fw-500  mb-2">{trans.text}</div>
        <div className={edit || data.new ? "" : "quill-readonly"}>
          <Editor
            key={`news-tab${index}`}
            editorHtml={editorHtml}
            setEditorHtml={setEditorHtml}
            handleChange={handleTextEditorChange}
            readonly={!edit && !data.new}
          />
        </div>
      </Form>
    </div>
  );
};
